import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import SideBar from "../../common/sideBar";
import { axiosInstnace as Axios } from "../../../../util/util";
import { endPoints } from "../../../../config";
import useModel from "../../common/useModel";
import Model from "../../common/packageModel";
import HeaderAdminpanel from "../../common/HeaderAdminpanel";  
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

const RateCard = (props) => {
  //Initial state
  const [packages, handlePackage] = useState([]);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const { isShowing, toggle } = useModel();
  const [rates, handleRates] = useState([]);
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  useEffect(() => {
    getPackage(0);
  }, []);

  //Update rate for frequency bassed package
  const updateRate = async (params) => {
    try {
      const data = await Axios.put(endPoints.updateFrequencyPackage, params);
      const result = data.data.data.data;
      if (result && !toast.isActive("1")) {
        toast.success("Changes successfully updated", {
          position: toast.POSITION.TOP_CENTER,

          hideProgressBar: true,
          toastId: "1",
        });

        getPackage(0);
        toggle();
      }
    } catch (error) {
      console.log(error);
    }
  };

  //Get package Info
  const getPackage = async (skip) => {
    handleSkip(skip);
    try {
      const data = await Axios.get(endPoints.getPackage, {
        params: {
          skip,
          type: "frequency",
        },
      });
      const result = data.data.data.data;
      if (result) {
        handlePackage(result);
        handleCount(data.data.data.count);
      }
    } catch (error) {
      console.log(error);
      handleRodp([]);
    }
  };

  const openPopup = (rates) => {
    handleRates(rates);
    toggle();
  };

  return (
    <div className="dashboardContainer">
      <Model isShowing={isShowing} hide={toggle} rates={rates} updateRate={updateRate} />
      <HeaderAdminpanel/>

      {/* <div className="navbar-header dashboard-header clearfix">
        <div className="logo-dashboard">
          <a id="logo">
            <img className="logo-trans" src="/assets/images/new_logo.png" />
          </a>
          <span>Welcome: {adminData.email} </span>
          <span>Last Login @ {moment(adminData.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>
        </div>
        <div
          className="user-profile pull-right"
          tabIndex={0}
          onClick={() => {
            localStorage.removeItem("adminInfo");
            window.location.href = "/admin/login";
          }}
        >
          <a>
            <span>
              LOGOUT
              <span className="log_img">
                <img src="/assets/images/ic_logout.png" />
              </span>
            </span>
          </a>
        </div>
      </div> */}
      <div className="dashboardContainer-inner">
        <section id="sidebar">
          <SideBar />
        </section>
        <section id="dashboard-rightContainer" className="dashboard-manageSales">
          <div className="container-head">
            <div className="dashboard-breadcrumb">
              Manage Package |
              <span className="breadcrumb-active fct-breadcrumb">Manage Frequency Package</span>
            </div>
          </div>
          <div className="dashboard-content userListing-dashboard bg-white table-responsive">
            <table className="table table-striped master-table">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Fct Per Day</th>
                  <th>Type</th>
                  <th>Additional Discount (%)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {packages.map((r) => (
                  <tr>
                    <td>{r.days}</td>
                    <td>{r.fctPerDay}</td>
                    <td>{r.name}</td>
                    <td>{r.discount}</td>
                    <td className="">
                      <a>
                        <span
                          className="tooltip-reject fct-edit"
                          onClick={openPopup.bind(this, r, packages[r - 1], packages[r + 1])}
                        >
                          <img src="/assets/images/edit.png" />
                          <span>Edit</span>
                        </span>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="paginationTable"></div>
          </div>
        </section>
      </div>
      <ToastContainer />
    </div>
  );
};

export default connect(null, {})(RateCard);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/managePackage.js/frequency.js